export const MenuItemsData = [
  {
    id: 1,
    title: 'Green Molecules',
    subItems: [
      { title: 'Hydrogen', path: '/hydrogen#green-molecules' },
      { title: 'Why Green Molecules', path: '/hydrogen#why-green-molecules' },
    ],
  },
  {
    id: 2,
    title: 'Technology',
    subItems: [
      { title: 'Green Molecules Electrolysers', path: '/technology/green-Molecules-electrolysers' },
      { title: 'PV Electrolyser Modules', path: '/technology/pv-electrolyser-modules' },
    ],
  },
  // {
  //   id: 3,
  //   title: 'Worldwide',
  //   subItems: [
  //     { title: 'Resources', path: '/worldwide' },
  //     { title: 'Articles', path: '/worldwide#articles' },
  //   ],
  // },
  {
    id: 4,
    title: 'Organization',
    subItems: [
      { title: 'Our Story', path: '/organization' },
      { title: 'Our Mission', path: '/organization#our-mission' },
      { title: 'Our Vision', path: '/organization#our-vision' },
    ],
  },
];